(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[77616],{

/***/ 98588:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signup",
      function () {
        return __webpack_require__(76951);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 76951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Auth_Signup__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38255);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var constant_url__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99741);
/* harmony import */ var constant_url__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(constant_url__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _api_api__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10107);
/* harmony import */ var _utils_discourse_auth__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(65233);
/* harmony import */ var constant_functions__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(60538);
/* harmony import */ var _utils_tradly_integration_auth__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(20435);
/* harmony import */ var _components_TopNotification__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(43741);












// import Header from '../partials/Header';
function SignUp(param) {
    var isLoggedIn = param.isLoggedIn;
    var ref, ref1, ref2;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var redirect_url = router.query.to || constant_url__WEBPACK_IMPORTED_MODULE_6__.default_site_url;
    var sso = (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.sso) || (router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.payload);
    var sig = router.query.sig;
    var identifier = router === null || router === void 0 ? void 0 : (ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.identity;
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), is_log_in_by_discourse = ref3[0], setISlogInByDiscourse = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), is_log_in_by_tradly_integration = ref4[0], setISlogInByTradlyIntegration = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), hideNt = ref5[0], setHideNt = ref5[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!isLoggedIn && sso && sig && identifier === "tradly") {
            setISlogInByTradlyIntegration(true);
        } else if (!isLoggedIn && sso && sig && (identifier !== "tradly" || identifier === undefined)) {
            setISlogInByDiscourse(true);
        } else if (isLoggedIn && sso && sig) {
            var auth_key = (0,constant_functions__WEBPACK_IMPORTED_MODULE_9__.getAuthKey)();
            if (identifier !== undefined) {
                (0,_api_api__WEBPACK_IMPORTED_MODULE_7__/* .getUserDetails */ .M_)(auth_key).then(function(res) {
                    if (res === null || res === void 0 ? void 0 : res.user) {
                        (0,_utils_discourse_auth__WEBPACK_IMPORTED_MODULE_8__/* .discourse_redirect */ .kM)({
                            sso: sso,
                            sig: sig,
                            user: res === null || res === void 0 ? void 0 : res.user,
                            router: router
                        });
                    } else {
                        router.push(redirect_url);
                    }
                }).catch(function(error) {
                    router.push(redirect_url);
                });
            } else if (identifier === "tradly") {
                (0,_api_api__WEBPACK_IMPORTED_MODULE_7__/* .getUserDetails */ .M_)(auth_key).then(function(res) {
                    if (res === null || res === void 0 ? void 0 : res.user) {
                        (0,_utils_tradly_integration_auth__WEBPACK_IMPORTED_MODULE_10__/* .tradly_integration_redirect */ .we)({
                            sso: sso,
                            sig: sig,
                            user: res === null || res === void 0 ? void 0 : res.user,
                            router: router
                        });
                    } else {
                        router.push(redirect_url);
                    }
                }).catch(function(error) {
                    router.push(redirect_url);
                });
            }
        } else if (isLoggedIn) {
            router.push(redirect_url);
        }
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: "Tradly – Bring your Dream into Reality. API-FIRST COMMERCE."
                    }, "twitter:title"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: "Tradly – Bring your Dream into Reality. API-FIRST COMMERCE."
                    }, "og:title"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Tradly - Signup"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex flex-col min-h-screen overflow-hidden",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                    className: "flex-grow",
                    children: is_log_in_by_discourse ? (0,_utils_discourse_auth__WEBPACK_IMPORTED_MODULE_8__/* .check_discourse_payload */ .wL)({
                        component: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Auth_Signup__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            sso: sso,
                            sig: sig,
                            is_log_in_by_discourse: is_log_in_by_discourse
                        }),
                        sso: sso,
                        sig: sig
                    }) : is_log_in_by_tradly_integration ? (0,_utils_tradly_integration_auth__WEBPACK_IMPORTED_MODULE_10__/* .check_tradly_auth_integration_payload */ .K4)({
                        component: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Auth_Signup__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            sso: sso,
                            sig: sig,
                            is_log_in_by_tradly_integration: is_log_in_by_tradly_integration
                        }),
                        sso: sso,
                        sig: sig
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Auth_Signup__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        sso: sso,
                        sig: sig,
                        isLoggedIn: isLoggedIn
                    })
                })
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (SignUp);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [33714,87536,26281,88000,38255,49774,92888,40179], function() { return __webpack_exec__(98588); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);